import { render, staticRenderFns } from "./HelpCenterSectionTitle.vue?vue&type=template&id=40a4ca01&scoped=true&"
import script from "./HelpCenterSectionTitle.vue?vue&type=script&lang=js&"
export * from "./HelpCenterSectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterSectionTitle.vue?vue&type=style&index=0&id=40a4ca01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a4ca01",
  null
  
)

export default component.exports